import { Component, Injector, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationCancel, NavigationEnd, Router } from '@angular/router';
import { DrawerComponent, MenuComponent, ScrollComponent, ToggleComponent } from '@metronic/app/kt/components';
import AppComponentBase from '@shared/common/app-component-base';
import { FormattedStringValueExtracter } from '@shared/helpers/FormattedStringValueExtracter';
import { ThemeAssetContributorFactory } from '@shared/helpers/ThemeAssetContributorFactory';
import { PermissionCheckerService } from 'abp-ng2-module';
import objectPath from 'object-path';
import { filter } from 'rxjs/operators';

import AppMenu from './app-menu';
import AppNavigationService from './app-navigation.service';

@Component({
    templateUrl: './top-bar-menu.component.html',
    selector: 'top-bar-menu',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
class TopBarMenuComponent extends AppComponentBase implements OnInit {

    @Input() menuClass = 'menu menu-lg-rounded menu-column menu-lg-row menu-state-bg ' +
        'menu-title-gray-700 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary ' +
        'menu-arrow-gray-400 fw-bold my-5 my-lg-0 align-items-stretch';

    menu: AppMenu = null;

    currentRouteUrl: any = '';

    menuWrapperStyle = '';

    constructor(
        injector: Injector,
        private router: Router,
        public permission: PermissionCheckerService,
        private _appNavigationService: AppNavigationService,
    ) {
        super(injector);
    }

    ngOnInit() {
        this.menu = this._appNavigationService.getMenu();
        this.currentRouteUrl = this.router.url.split(/[?#]/)[0];
        this.menuWrapperStyle = ThemeAssetContributorFactory.getCurrent()
            .getMenuWrapperStyle();

        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe(() => this.currentRouteUrl = this.router.url.split(/[?#]/)[0]);

        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd || event instanceof NavigationCancel))
            .subscribe(() => {
                this.reinitializeMenu();
            });
    }

    reinitializeMenu(): void {
        this.menu = this._appNavigationService.getMenu();
        this.currentRouteUrl = this.router.url.split(/[?#]/)[0];

        setTimeout(() => {
            MenuComponent.reinitialization();
            DrawerComponent.reinitialization();
            ToggleComponent.reinitialization();
            ScrollComponent.reinitialization();
        }, 50);
    }

    showMenuItem(menuItem): boolean {
        return this._appNavigationService.showMenuItem(menuItem);
    }

    getItemCssClasses(item) {
        let classes = 'menu-item';

        // custom class for menu item
        const customClass = objectPath.get(item, 'custom-class');
        if (customClass) {
            classes += ' ' + customClass;
        }

        if (this.isMenuItemIsActive(item)) {
            classes += ' show';
        }

        return classes;
    }

    getAnchorItemCssClasses(): string {
        const cssClasses = 'menu-link without-sub py-3';

        return cssClasses;
    }

    getSubmenuCssClasses(): string {
        return 'menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-rounded-0 py-lg-4 w-lg-225px';
    }

    isMenuItemIsActive(item): boolean {
        if (item.items.length) {
            return this.isMenuRootItemIsActive(item);
        }

        if (!item.route) {
            return false;
        }

        const urlTree = this.router.parseUrl(this.currentRouteUrl.replace(/\/$/, ''));
        const urlString = '/' + urlTree.root.children.primary.segments.map((segment) => segment.path)
            .join('/');
        const exactMatch = urlString === item.route.replace(/\/$/, '');
        if (!exactMatch && item.routeTemplates) {
            for (let i = 0; i < item.routeTemplates.length; i++) {
                const result = new FormattedStringValueExtracter()
                    .Extract(urlString, item.routeTemplates[i]);
                if (result.IsMatch) {
                    return true;
                }
            }
        }
        return exactMatch;
    }

    isMenuRootItemIsActive(item): boolean {
        let result = false;

        for (const subItem of item.items) {
            result = this.isMenuItemIsActive(subItem);
            if (result) {
                return true;
            }
        }

        return false;
    }

    getItemAttrSubmenuToggle(menuItem, parentItem, depth) {
        if (depth && depth >= 1) {
            return 'hover';
        }
        return 'click';

    }

    isMobileDevice(): any {
        return KTUtil.isMobileDevice();
    }
}

export default TopBarMenuComponent;
